import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getEncounterRows } from "./encounter-rows";

export const metadata = {
  tableType: "Encounter",
  displayName: "Encounters",
  getRows: (bundle: FhirBundleSdk) => getEncounterRows({ bundle }),
};
